import React from "react";
import accounting from "accounting";
import StringField from "./StringField";

const normalizeInteger = value => accounting.unformat(value);

const IntegerField = props => (
  <StringField
    type="number"
    step={1}
    min={0}
    normalize={normalizeInteger}
    {...props}
  />
);

export default IntegerField;



// WEBPACK FOOTER //
// ./components/common/form-field/IntegerField.js